import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, output } from '@angular/core';
import { DesyAngularModule } from 'desy-angular';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-search-bar',
  imports: [DesyAngularModule, CommonModule],
  templateUrl: './search-bar.component.html',
})
export class SearchBarComponent implements OnInit {
  @Input() showExternalButton: boolean = false;
  @Input() placeholder: string = 'Buscar';
  @Input() externalButtonPrimary: boolean = true;
  searchTextSubject = new Subject<string>();
  search = output<string>();
  search2: string = '';

  onSearchInput(value: string): void {
    if (!this.showExternalButton) {
      this.searchTextSubject.next(value);
    }
  }

  onExternalButtonClick(value: string): void {
    this.search.emit(value);
  }

  onSearchBarClick(value: string): void {
    if (!this.showExternalButton) {
      this.search.emit(value);
    }
  }

  stopNativeSearch(event: Event): void {
    event.stopPropagation();
  }

  onKeyDown(event: KeyboardEvent, value: string): void {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.search.emit(value);
    }
  }

  ngOnInit(): void {
    this.searchTextSubject.pipe(debounceTime(300)).subscribe((value: string) => {
      if (!this.showExternalButton) {
        this.search.emit(value);
      }
    });
  }
}
